import React, { useContext, useEffect, useState } from 'react';
import { Button, Grid, MenuItem, Paper, Select, TextField } from '@material-ui/core';

import { fbmApi as api } from 'api/fbm';
import { UserContext } from 'contexts/UserContext';
import { DataTable, Notifications } from 'shared';
import dayjs from 'utils/dayjsConfig';

function ViewOnTimeDelivery() {
    const [rows, setRows] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });
    const [reportIsReady, setReportIsReady] = useState(false);
    const [reportButtonText, setReportButtonText] = useState('Loading...');

    const [reportStartDate, setReportStartDate] = React.useState(dayjs().format('YYYY-MM-DD'));
    const handleReportStartDateChange = (event) => {
        setReportStartDate(event.target.value);
    };

    const [reportEndDate, setReportEndDate] = React.useState(dayjs().format('YYYY-MM-DD'));
    const handleReportEndDateChange = (event) => {
        setReportEndDate(event.target.value);
    };

    const { fbmAccount } = useContext(UserContext);

    const handleRunReportClick = (event) => {
        getAndRenderReportData();
    };

    const columns = [
        { accessor: 'estimated_delivery_date', Header: 'Est Delv Date', width: 125 },
        { accessor: 'order_id', Header: 'Order ID', width: 100 },
        { accessor: 'shipment_id', Header: 'Shipment ID', width: 125 },
        { accessor: 'tracking_number', Header: 'Tracking #', width: 150 },
        { accessor: 'status', Header: 'Status', width: 100 },
        { accessor: 'facility', Header: 'Facility', width: 100 },
        { accessor: 'carrier', Header: 'Carrier', width: 100 },
        { accessor: 'otd_status', Header: 'On Time Status', width: 150 },
        { accessor: 'line_haul', Header: 'Line Haul', width: 150 },
        { accessor: 'pack_day', Header: 'Pack Day', width: 125 },
        { accessor: 'injection_day', Header: 'Injection Day', width: 150 },
        { accessor: 'zip', Header: 'Zip', width: 150 },
        { accessor: 'fbm_order_num', Header: 'Partner Order Number', width: 150 },
    ];

    let getAndRenderReportData = async () => {
        setReportIsReady(false);

        setReportButtonText('Loading...');
        setRows([]);

        const response = await api.getReportOnTimeDeliveryView(
            fbmAccount.fbmAccountName,
            reportStartDate,
            reportEndDate,
        );

        if (response.status === false) {
            setNotification({ text: `No entries found ${response.msg}`, level: 'error' });
            setReportButtonText('Run Report');
            setReportIsReady(true);
            return;
        }

        setRows(
            (response.data?.rows ?? []).map((item) => {
                item.estimated_delivery_date = item.estimated_delivery_date
                    ? dayjs(item.estimated_delivery_date).format('YYYY-MM-DD')
                    : '';
                item.pack_day = item.pack_day ? dayjs(item.pack_day).format('YYYY-MM-DD') : '';
                item.injection_day = item.injection_day ? dayjs(item.injection_day).format('YYYY-MM-DD') : '';
                return item;
            }),
        );

        setReportButtonText('Run Report');
        setReportIsReady(true);
    };

    useEffect(() => {
        if (fbmAccount.id) {
            getAndRenderReportData();
        }
    }, [fbmAccount]);

    return (
        <Paper>
            <Notifications options={notification} />

            <Grid container>
                <Grid item xs={12}>
                    <h2>{fbmAccount.companyName} - On Time Delivery Report</h2>

                    <Grid item md={12} style={{ paddingRight: '35px' }}>
                        <TextField
                            id="reportStartDate"
                            label="Start Date"
                            type="date"
                            defaultValue={reportStartDate}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            disabled={!reportIsReady}
                            onChange={handleReportStartDateChange}
                            style={{ marginRight: '50px' }}
                        />

                        <TextField
                            id="reportEndDate"
                            label="End Date"
                            type="date"
                            defaultValue={reportEndDate}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            disabled={!reportIsReady}
                            onChange={handleReportEndDateChange}
                            style={{ marginRight: '50px' }}
                        />

                        <Button
                            id="runReport"
                            onClick={handleRunReportClick}
                            color="secondary"
                            disabled={!reportIsReady}
                        >
                            {reportButtonText}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>

            <br />
            <span>Note: The date parameters are applied to the estimated delivery date.</span>

            <DataTable
                csvExport={reportIsReady}
                csvExportFileName="on-time-delivery"
                csvExportHeadersUseAccessor
                columns={columns}
                data={rows}
                editable={false}
            />
        </Paper>
    );
}

export { ViewOnTimeDelivery };
